let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("994Gp")).then(() => parcelRequire('kMxK3'));